import { render } from "./PaginatorRange.vue?vue&type=template&id=605c4069"
import script from "./PaginatorRange.vue?vue&type=script&lang=js"
export * from "./PaginatorRange.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\ecommunity\\vms-admin.sg\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__